import { gql } from '@apollo/client';

export const STRIPE_CHECKOUT_LINK = gql`
  query stripeCheckoutLink(
    $plan: String!
    $isMonthly: Boolean
    $blogId: String!
  ) {
    stripeCheckoutLink(plan: $plan, isMonthly: $isMonthly, blogId: $blogId)
  }
`;

export const STRIPE_CUSTOMER_PORTAL_LINK = gql`
  query stripeCustomerPortalLink($blogId: String!) {
    stripeCustomerPortalLink(blogId: $blogId)
  }
`;
